<div class="items">
  <span class="item">&copy; {{ currentYear }} Medical Home Network</span>
  <a class="item" href="{{ termsOfUseLink }}" target="_blank">Terms of Use</a>
  <a class="item" href="{{ privacyPolicyLink }}" target="_blank">Privacy Policy</a>
  <a class="item" href="{{ policiesAndProceduresLink }}" target="_blank">Policies and Procedures</a>
  <a class="item" href="{{ complianceLink }}" target="_blank">Compliance</a>
</div>

<div class="text-nowrap" *ngIf="releaseNumber">Build number: {{ releaseNumber }}</div>

<div class="floating-actions" *ngIf="authService.isEntitled('/feedback/addFeedback.html')">
  <button
    class="btn btn-primary"
    type="button"
    ngbTooltip="Submit Feedback"
    placement="top-end"
    triggers="mouseenter:mouseleave"
    (click)="openFeedbackModal(userFeedback)"
    aria-label="Feedback"
  >
    <i class="fa-regular fa-comment-dots fa-lg"></i>
  </button>

  <ng-template #userFeedback let-modal>
    <div class="modal-body">
      <th-feedback></th-feedback>
    </div>
  </ng-template>
</div>
